import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ShimmerTable, ShimmerTitle, ShimmerCircularImage } from "react-shimmer-effects";
import Chart from 'react-apexcharts';


const Competition = () => {

    const [onLoading, setOnLoading] = useState(false)
    const [screenWidth, setScreenWidth] = useState(1000);

    useEffect(() => {
        setScreenWidth (window.innerWidth - ((window.innerWidth * 25)/100))
    }, []);

    const competitorColors = ['#FF5733', '#33FF57', '#3357FF', '#FF33EB'];

  // Data for the chart
  const chartData = [40, 40, 10, 10];

  // Chart options
  const chartOptions = {
    labels: ['Competitor A', 'Competitor B', 'Competitor C', 'Competitor D'],
    colors: competitorColors,
    legend: {
      show: true,
      position: 'right', // Legend position to the right
      labels: {
        colors: '#ffffff' // All text white
      }
    }
  };
   
    return (
        <div style={{
            width: '49%', marginLeft: 0, display: 'flex', 
            flexDirection: 'column', height: 450,
            marginTop: '2%', background: 'linear-gradient(135deg, #161c2a, #1a2130)', padding: 20, borderRadius: 15
        }}>



            {onLoading &&

                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 100 }}>

                    <ShimmerCircularImage size={500} />
                    <ShimmerCircularImage size={500} />
                </div>
            }



            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 10 }}>


                <div style={{ width: '100%' }}>

                    <h4 style={{ color: '#fff', textAlign: 'left' }}>Competition</h4>
                    <span className="whiteSpan">Your local search presence vs your competitors</span>

                    <hr />


                    <div style={{ display: 'flex', flexDirection: 'column',
                     justifyContent: 'space-between', alignItems:'center' }}>

                    <Chart
      options={chartOptions}
      series={chartData}
      type="donut"
      height={300} 
      width={screenWidth * 0.5}
    />



                        
                    </div>



                </div>


            </div>


        </div>
    );
};

export default Competition;
